
import Vue from "vue";
import DocumentOutlineIcon from "@/components/atoms/DocumentOutlineIcon.vue";

export default Vue.extend({
  components: { DocumentOutlineIcon },
});
